const menu = {
    label: '• Origem de Contratação',
    to: '/sol/origemcontratacao',
    rules: ['SOL-001'],
};

export default menu;
